/**
 * ProjectUserRole_BugGroupsEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectUserRoleEntity } from "../ProjectUserRoleEntity";
import { BugGroupEntity } from "../BugGroupEntity";
import { ProjectUserRole_BugGroupsEntity } from "../ProjectUserRole_BugGroupsEntity";
declare global {
    interface EntityTypeMap {
        ProjectUserRole_BugGroups: ProjectUserRole_BugGroupsEntity;
    }
}
export abstract class ProjectUserRole_BugGroupsGeneratedEntity extends BaseEntity {
    public abstract relationId: string;
    public abstract templateId: string | null;
    public abstract type: number;
    public abstract role: ProjectUserRoleEntity;
    public abstract bugGroup: BugGroupEntity | null;
}
